export default function reportsList() {
  return [
    {
      "id": "missingPreferredLabels",
      "category": "Preferred Labels",
      "title": {
        "en": "Concepts Missing Preferred Labels"
      },
      "projectType": "TaxonomyProject",
      "description": {
        "en": "List any concepts that do not have preferred labels in all project languages."
      },
      "query": `PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT DISTINCT ?Concept ?Default_Preferred_Label ?Missing_Language {
  ?project <https://grafsync.graphifi.com/schema/gs/projectLang> ?Missing_Language .
  ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
  ?Concept_IRI a skos:Concept .
  ?Concept_IRI (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?Default_Preferred_Label .
  FILTER (LANG(?Default_Preferred_Label) = ?defaultLang)      	
  FILTER NOT EXISTS {
    ?Concept_IRI (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?PrefLabel .
    FILTER (LANG(?PrefLabel) = ?Missing_Language)      			
  }
  OPTIONAL {
    ?Concept_IRI <https://grafsync.graphifi.com/schema/gs/iri> ?sIriList .
    ?sIriList <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest>* ?sIriListItem .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#first> ?Concept_New_IRI .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest> <http://www.w3.org/1999/02/22-rdf-syntax-ns#nil> .
  }
  BIND(IF(BOUND(?Concept_New_IRI), ?Concept_New_IRI, ?Concept_IRI) AS ?Concept)
}
ORDER BY ?Default_Preferred_Label ?Missing_Language
LIMIT 100`
    },
    {
      "id": "preferredLabelLengths",
      "category": "Preferred Labels",
      "title": {
        "en": "Preferred Label Lengths"
      },
      "projectType": "TaxonomyProject",
      "description": {
        "en": "The distribution of preferred label lengths across the project in the default project language."
      },
      "barChart": ["Label_Length", "Concept_Count"],
      "query": `PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT DISTINCT ?Label_Length (COUNT(?concept) as ?Concept_Count) {
  GRAPH ?g {    
    ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
    ?concept a skos:Concept .
    ?concept (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?Default_Preferred_Label .
    FILTER (LANG(?Default_Preferred_Label) = ?defaultLang)      	
    BIND (STRLEN(STR(?Default_Preferred_Label)) AS ?Label_Length)
    
  }
}
GROUP BY ?Label_Length
ORDER BY ASC(?Label_Length)`
    },
    {
      "id": "labelLengths",
      "category": "Labels",
      "title": {
        "en": "Label Lengths"
      },
      "projectType": "OntologyProject",
      "description": {
        "en": "The distribution of label lengths across the project in the default project language."
      },
      "barChart": ["Label_Length", "Resource_Count"],
      "query": `PREFIX xowl: <https://graphifi.com/schema/xowl/>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT DISTINCT ?Label_Length (COUNT(?resource) as ?Resource_Count) {
  GRAPH ?g {    
    ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
    ?resource a ?type .
    VALUES ?type {owl:Class owl:ObjectProperty owl:DatatypeProperty owl:AnnotationProperty}
    FILTER (?resource NOT IN (owl:Thing, owl:topObjectProperty, owl:topDataProperty, xowl:topAnnotationProperty))
    ?resource rdfs:label ?Label .
    FILTER (LANG(?Label) = ?defaultLang)      	
    BIND (STRLEN(STR(?Label)) AS ?Label_Length)    
  }
}
GROUP BY ?Label_Length
ORDER BY ASC(?Label_Length)`
    },
    {
      "id": "editCounts",
      "category": "Edits",
      "title": {
        "en": "Edit Counts"
      },
      "description": {
        "en": "List the number of recorded history edits over the past ten days for days that have had edits."
      },
      "barChart": ["Date", "Edit_Count"],
      "query": `SELECT DISTINCT ?Date (COUNT(?history) as ?Edit_Count) {
  GRAPH ?historyGraph {    
    ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?resource .
    ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
    BIND(STRDT(SUBSTR(STR(?changedTime), 0, 11), <http://www.w3.org/2001/XMLSchema#date>) AS ?Date)
  }
}
GROUP BY ?Date
ORDER BY DESC(?Date)
LIMIT 10`
    },
    {
      "id": "mostRecentlyEdited",
      "category": "Edits",
      "title": {
        "en": "Most Recently Edited Concepts"
      },
      "projectType": "TaxonomyProject",
      "description": {
        "en": "These are the most recently edited concepts from across the entire project."
      },
      "query": `PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT DISTINCT ?Concept ?Preferred_Label (MAX(?changedTime) as ?Last_Changed) {
GRAPH  ?historyGraph {    
  ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?Concept_IRI .
  ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
}
GRAPH ?projectGraph {
  ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
  ?Concept_IRI a skos:Concept .
  ?Concept_IRI (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?Preferred_Label .
  FILTER (LANG(?Preferred_Label) = ?defaultLang)
  OPTIONAL {
    ?Concept_IRI <https://grafsync.graphifi.com/schema/gs/iri> ?sIriList .
    ?sIriList <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest>* ?sIriListItem .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#first> ?Concept_New_IRI .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest> <http://www.w3.org/1999/02/22-rdf-syntax-ns#nil> .
  }
  BIND(IF(BOUND(?Concept_New_IRI), ?Concept_New_IRI, ?Concept_IRI) AS ?Concept)
}
}
GROUP BY ?Concept ?Preferred_Label
ORDER BY DESC(MAX(?changedTime))
LIMIT 100
      `
    },
    {
      "id": "unapprovedResources",
      "category": "Workflow",
      "title": {
        "en": "Taxonomies with Unapproved Resources"
      },
      "projectType": "TaxonomyProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "Taxonomies with workflow activated and that have unapproved concepts or XL labels. (Deprecated resources are not included.)"
      },
      "barChart": ["Title", "Unapproved_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT ?Title (COUNT(?resource) AS ?Unapproved_Count) ?Taxonomy WHERE {
  ?Taxonomy a skos:ConceptScheme .
  ?Taxonomy gs:activateWorkflow true .
  ?project gs:defaultLang ?defaultLang .
  OPTIONAL {
    ?Taxonomy dct:title ?Title .
    FILTER (LANG(?Title) = ?defaultLang)      	
  }
  ?resource skos:inScheme ?Taxonomy .
  FILTER NOT EXISTS {
    ?resource gs:status gs:accepted .
  }
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?Taxonomy ?Title 
ORDER BY DESC(?Unapproved_Count)
LIMIT 100`
    },
    {
      "id": "withUnapprovedXL",
      "category": "Workflow",
      "title": {
        "en": "Approved Concepts with Unapproved XL Labels"
      },
      "projectType": "TaxonomyProject",
      "skosXL": true,
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "Approved concepts in taxonomies with workflow activated and that have unapproved XL labels. (Deprecated resources are not included.)"
      },
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT ?Default_Preferred_Label ?Concept ?Taxonomy WHERE {
  ?Taxonomy a skos:ConceptScheme .
  ?Taxonomy gs:activateWorkflow true .
  ?project gs:defaultLang ?defaultLang .
  ?Concept a skos:Concept .
  ?Concept skos:inScheme ?Taxonomy .
  ?Concept gs:status gs:accepted .
  ?Concept (skosxl:prefLabel | skosxl:altLabel | skosxl:hiddenLabel) ?xlLabel .
  FILTER NOT EXISTS {
    ?xlLabel gs:status gs:accepted .
  }
  FILTER NOT EXISTS {
    ?Concept gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?Concept owl:deprecated true .
  }
  ?Concept skosxl:prefLabel/skosxl:literalForm ?Default_Preferred_Label .
  FILTER (LANG(?Default_Preferred_Label) = ?defaultLang)      
}
ORDER BY ?Default_Preferred_Label
LIMIT 100`
    },
    {
      "id": "assignments",
      "category": "Workflow",
      "title": {
        "en": "Workflow Assignments"
      },
      "projectType": "TaxonomyProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "The assignment of draft workflow tasks across project users."
      },
      "barChart": ["User", "Assignment_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT ?User (COUNT(?resource) AS ?Assignment_Count) WHERE {
  VALUES ?resourceType {skos:Concept skosxl:Label}
  ?resource a ?resourceType .
  ?resource gs:assignedUser ?User .
  ?resource skos:inScheme ?scheme .
  ?scheme gs:activateWorkflow true .
  ?resource gs:status ?draft .
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?User
ORDER BY DESC(?Assignment_Count)`
    },
    {
      "id": "suggestions",
      "category": "Workflow",
      "title": {
        "en": "Taxonomies with Open Suggestions"
      },
      "projectType": "TaxonomyProject",
      "barChart": ["Title", "Count"],
      "description": {
        "en": "Taxonomies that have suggestions that have an open status."
      },
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>

SELECT DISTINCT ?Taxonomy ?Title (COUNT(?suggestion) AS ?Count) WHERE {
  ?Taxonomy a skos:ConceptScheme .
  ?project gs:defaultLang ?defaultLang .
  OPTIONAL {
    ?Taxonomy dct:title ?Title .
    FILTER (LANG(?Title) = ?defaultLang)      	
  }
  ?suggestion <https://grafsync.graphifi.com/schema/vm/suggestionSourceConcept> ?source .
  ?suggestion skos:inScheme ?Taxonomy .
  ?suggestion gs:status gs:pending .
  FILTER NOT EXISTS {
    ?source gs:pendingDeletion true .
  }
}
GROUP BY ?Taxonomy ?Title
ORDER BY DESC(?Count) ?Title
LIMIT 100`
    }
  ];
}